module.exports = __webpack_public_path__ + "assets/img/effect_(7).20d8de2c.gif";